// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-bar {
  position: relative;
  width: 20%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #ECECEC;
}
.nav-bar__top {
  padding-left: 4.5%;
  margin-top: 10%;
}
.nav-bar__top .shop-selected, .nav-bar__top .shop {
  display: flex;
  flex-direction: row;
  justify-content: initial !important;
  gap: 30px;
  padding-left: 20px;
  align-items: center;
}
.nav-bar__top__sections {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.nav-bar__top__sections:not(:first-child) {
  margin-top: 3vh;
}
.nav-bar__top__sections__section {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.nav-bar__top__sections__section__label {
  font-size: 0.85rem;
  color: #9B9B9B;
  padding: 0 0.5rem;
  text-wrap: nowrap;
  width: fit-content;
}
.nav-bar__top__sections__section:nth-last-child(1) {
  position: absolute;
  width: 100%;
  bottom: 4rem;
}
.nav-bar__top__sections__module {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 2.5rem;
  font-size: 1rem;
  font-family: "Inter";
  width: 95%;
  color: #211A1A;
  cursor: pointer;
}
.nav-bar__top__sections__module__icon {
  margin-left: 10px;
}
.nav-bar__top__sections__module__text {
  display: flex;
  width: 80%;
  align-items: center;
  text-align: left;
  padding: 0 12px;
  text-wrap: nowrap;
}
.nav-bar__top__sections__module.selected {
  background-color: #F3F3F3;
  border-radius: 7px;
}
.nav-bar__top__sections__module.disabled {
  opacity: 0.5;
}
.nav-bar__footer {
  padding-left: 0;
  border-top: 1px solid #ECECEC;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
}
.nav-bar__footer__text {
  font-size: 0.85rem;
  color: #525252;
  padding: 1rem 0;
}

.shop {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  gap: 1rem;
  padding: 0.3rem 0rem 0.3rem 0.1rem;
  width: 80%;
}
.shop > img {
  width: 1.6rem;
  height: 1.6rem;
}
.shop__details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.shop__details__name {
  font-size: 0.9rem;
  color: #4F4BFF;
}
.shop__details__address {
  font-size: 0.7rem;
  color: #828282;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shop-dropdown {
  border-radius: 8px;
  width: 95%;
}`, "",{"version":3,"sources":["webpack://./src/features/common/components/SideBar/SideBar.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,+BAAA;AACJ;AAAI;EACI,kBAAA;EACA,eAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAGZ;AADQ;EAII,aAAA;EACA,sBAAA;EACA,WAAA;AAAZ;AALY;EACI,eAAA;AAOhB;AADY;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAGhB;AADgB;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAGpB;AAAgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAEpB;AACY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAChB;AAAgB;EACI,iBAAA;AAEpB;AAAgB;EACI,aAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAEpB;AAAgB;EACI,yBAAA;EACA,kBAAA;AAEpB;AAAgB;EACI,YAAA;AAEpB;AAGI;EACI,eAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADR;AAEQ;EACI,kBAAA;EACA,cAAA;EACA,eAAA;AAAZ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;EACA,UAAA;AAFJ;AAGI;EACI,aAAA;EACA,cAAA;AADR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AADR;AAEQ;EACI,iBAAA;EACA,cAAA;AAAZ;AAEQ;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAZ;;AAIA;EACI,kBAAA;EACA,UAAA;AADJ","sourcesContent":[".nav-bar{\n    position: relative;\n    width: 20%;\n    height: 100%;   \n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    border-right: 1px solid #ECECEC;\n    &__top{\n        padding-left: 4.5%;\n        margin-top: 10%;\n        .shop-selected, .shop{\n            display: flex;\n            flex-direction: row;\n            justify-content: initial !important;\n            gap: 30px;\n            padding-left: 20px;\n            align-items: center;\n        }\n        &__sections{\n            &:not(:first-child){\n                margin-top: 3vh;\n            }\n            display: flex;\n            flex-direction: column;\n            gap: 1.2rem;\n\n            &__section{\n                display: flex;\n                flex-direction: column;\n                gap: 0.3rem;\n                \n                &__label{\n                    font-size: 0.85rem;\n                    color: #9B9B9B;\n                    padding: 0 0.5rem;\n                    text-wrap: nowrap;\n                    width: fit-content;\n                }\n\n                &:nth-last-child(1){\n                    position: absolute;\n                    width: 100%;\n                    bottom: 4rem;\n                }\n            }\n            &__module{\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                height: 2.5rem;\n                font-size: 1rem;\n                font-family: 'Inter';\n                width: 95%;\n                color:#211A1A;\n                cursor: pointer;\n                &__icon{\n                    margin-left: 10px;\n                }\n                &__text{\n                    display: flex;\n                    width: 80%;\n                    align-items: center;\n                    text-align: left;\n                    padding: 0 12px;\n                    text-wrap: nowrap;\n                }\n                &.selected{\n                    background-color: #F3F3F3;\n                    border-radius: 7px;\n                }\n                &.disabled{\n                    opacity: 0.5;\n                }\n            }\n        }\n    }\n    &__footer{\n        padding-left: 0;\n        border-top: 1px solid #ECECEC;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 3rem;\n        &__text{\n            font-size: 0.85rem;\n            color: #525252;\n            padding: 1rem 0;\n        }\n    }\n}\n\n.shop{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.3rem 0rem 0.3rem 0.1rem;\n    width: 80%;\n    >img{\n        width: 1.6rem;\n        height: 1.6rem;\n    }\n    &__details{\n        display: flex;\n        flex-direction: column;\n        gap: 0.25rem;\n        &__name{\n            font-size: 0.9rem;\n            color: #4F4BFF;\n        }\n        &__address{\n            font-size: 0.7rem;\n            color: #828282;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n    }\n}\n.shop-dropdown{\n    border-radius: 8px;\n    width: 95%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
